/* eslint-disable react/no-multi-comp */
/* eslint-disable react/static-property-placement */
/* eslint-disable max-classes-per-file */
/* eslint-disable @typescript-eslint/ban-types */
// vendor modules
import PropTypes from "prop-types"
import React, { Component } from "react"
import { isAnyFeatureEnabled, isFeatureEnabled } from "shared/featureflags/helperFunctions"
import {
    BulkSMSStatisticsFilterGroup,
    BulkSMSDetailsFilterGroup,
    BulkSMSRecipientsFilterGroup,
    BulkSMSCreatedDateFilterGroup,
} from "shared/search/containers/FilterGroup/BulkSMSFilterGroups"

import { AgencyRegionFilterGroup } from "shared/search/containers/FilterGroup/AgencyFilterGroups"
import {
    AlertAlertGroupFilterGroup,
    AlertCreatorFilterGroup,
    AlertDataTypeFilterGroup,
    AlertFrequencyFilterGroup,
    AlertUpdateTypeFilterGroup,
} from "shared/search/containers/FilterGroup/AlertFilterGroups"
import {
    AmendmentBillFilterGroup,
    AmendmentCommitteeProfileFilterGroup,
    AmendmentListFilterGroup,
    AmendmentOrderByFilterGroup,
    AmendmentPriorityFilterGroup,
    AmendmentProjectFilterGroup,
    AmendmentReviewFilterGroup,
    AmendmentSessionFilterGroup,
    AmendmentSponsorFilterGroup,
    AmendmentStanceFilterGroup,
    AmendmentStatusFilterGroup,
    AmendmentTypeFilterGroup,
} from "shared/search/containers/FilterGroup/AmendmentFilterGroups"
import {
    ArticleFilterGroups,
    ArticleTopicLevelFilterGroup,
} from "shared/search/containers/FilterGroup/ArticleFilterGroups"
import {
    BillCommitteeFilterGroup,
    // for Committee profile
    BillCommitteeProfileFilterGroup,
    BillCompanionFilterGroup,
    BillCustomFilterGroup,
    BillDataMaintenanceFilterGroup,
    BillDateFilterGroup,
    BillInvisibleFilterGroup,
    BillLanguageFilterGroup,
    BillListFilterGroup,
    // order_by
    BillOrderByFilterGroup,
    // for Organization profile
    BillOrganizationProfileFilterGroup,
    BillPriorityFilterGroup,
    BillProjectFilterGroup,
    BillRelatedFilterGroup,
    BillReviewFilterGroup,
    // eu
    BillSourceFilterGroup,
    BillSponsorFilterGroup,
    BillSponsorOfficialProfileFilterGroup,
    BillStanceFilterGroup,
    BillStatusFilterGroup,
    BillSupportedRegionFilterGroup,
    BillTermFilterGroup,
    BillTitleFilterGroup,
    BillTrackingDashboardFilterGroup,
    BillTypeFilterGroup,
} from "shared/search/containers/FilterGroup/BillFilterGroups"
import {
    BulkEmailDateFilterGroup,
    BulkEmailParticipantsFilterGroup,
    BulkEmailProjectFilterGroup,
    BulkEmailRecipientFilterGroup,
    BulkEmailStatisticsFilterGroup,
} from "shared/search/containers/FilterGroup/BulkEmailFilterGroups"
import {
    CampaignCreatorFilterGroup,
    CampaignDateFilterGroup,
    // CampaignStatisticsFilterGroup,
    CampaignProjectFilterGroup,
    CampaignStatusFilterGroup,
    CampaignTypeFilterGroup,
} from "shared/search/containers/FilterGroup/CampaignFilterGroups"
import {
    CaucusListFilterGroup,
    CaucusMemberFilterGroup,
    CaucusProjectFilterGroup,
    CaucusTypeFilterGroup,
} from "shared/search/containers/FilterGroup/CaucusFilterGroups"
import {
    CommitteeListFilterGroup,
    CommitteeMemberFilterGroup,
    CommitteeProjectFilterGroup,
    CommitteeSubcommitteeFilterGroup,
    CommitteeTypeFilterGroup,
    CommitteeCustomFilterGroup,
} from "shared/search/containers/FilterGroup/CommitteeFilterGroups"
import { CustomDataGeographicFilterGroup } from "shared/search/containers/FilterGroup/CustomDataFilterGroups"
import {
    CustomEventParticipantDateFilterGroup,
    CustomEventParticipantEventFilterGroup,
    CustomEventParticipantRecipientsFilterGroup,
    CustomEventParticipantStatusFilterGroup,
} from "shared/search/containers/FilterGroup/CustomEventParticipantFilterGroups"
import {
    DocketAssociatedObjectsFilterGroups,
    DocketDateFilterGroup,
    DocketOrderByFilterGroup,
    DocketPriorityFilterGroup,
    DocketSearchFilterGroup,
    DocketStanceFilterGroup,
    DocketTypeFilterGroup,
} from "shared/search/containers/FilterGroup/DocketFilterGroups"
import {
    // for Committee profile
    DocumentCommitteeProfileFilterGroup,
    DocumentDateFilterGroup,
    DocumentInvisibleFilterGroup,
    DocumentListFilterGroup,
    DocumentMembersOrganizationProfileFilterGroup,
    DocumentMentionCommsOnlyFilterGroup,
    DocumentMentionFilterGroup,
    DocumentOrderByFilterGroup,
    // for Organization profile
    DocumentOrganizationProfileFilterGroup,
    DocumentProjectFilterGroup,
    DocumentRegionFilterGroup,
    DocumentReviewFilterGroup,
    DocumentSourceFilterGroup,
    DocumentStanceFilterGroup,
    DocumentTrackingDashboardFilterGroup,
    DocumentTypeCommsOnlyFilterGroup,
    DocumentTypeFilterGroup,
    DocumentTypeSocialOnlyFilterGroup,
} from "shared/search/containers/FilterGroup/DocumentFilterGroups"
import {
    ElectionAmountFilterGroup,
    ElectionCycleFilterGroup,
    ElectionTypeFilterGroup,
} from "shared/search/containers/FilterGroup/ElectionFilterGroups"
import {
    EventChamberFilterGroup,
    EventRegionFilterGroup,
    // for Committee profile
    EventCommitteeProfileFilterGroup,
    EventDateFilterGroup,
    EventMentionFilterGroup,
    EventOrderByFilterGroup,
    // for Organization profile
    EventOrganizationProfileFilterGroup,
    EventProjectFilterGroup,
    EventTypeFilterGroup,
    // for Copilot
    EventSupportedRegionFilterGroup,
} from "shared/search/containers/FilterGroup/EventFilterGroups"
import { EventParticipantTypeFilterGroup } from "shared/search/containers/FilterGroup/EventParticipantFilterGroups"
import {
    FeedItemAdminFilterGroup,
    FeedItemAlertFilterGroup,
    FeedItemCreatorFilterGroup,
    FeedItemDatasetFilterGroup,
    FeedItemDataTypeFilterGroup,
    FeedItemDateFilterGroup,
    FeedItemDeliveryMediumFilterGroup,
    FeedItemFrequencyFilterGroup,
    FeedItemInvisibleFilterGroup,
    FeedItemIssueFilterGroup,
    FeedItemPriorityFilterGroup,
    FeedItemStanceFilterGroup,
    FeedItemUpdateTypeFilterGroup,
} from "shared/search/containers/FilterGroup/FeedItemFilterGroups"
import {
    FileListFilterGroup,
    FileOrderByFilterGroup,
    FileProjectFilterGroup,
} from "shared/search/containers/FilterGroup/FileFilterGroups"
import {
    AssignmentCreatorFilterGroup,
    AssignmentFilterGroup,
    AssignmentOrderingFilterGroup,
    AssignmentTypeFilterGroup,
    FromTrackingBoardInvisibleFilterGroup,
    InvisibleDefaultFilterGroup,
    RegionNoFederalFilterGroup,
} from "shared/search/containers/FilterGroup/FilterGroups"
import {
    GeographyPartyFilterGroup,
    GeographyStateAndCountyFilterGroup,
    GeographyStateFilterGroup,
    GeoShapeTypeFilterGroup,
    GeoShapeTypeForBriefBuilderFilterGroup,
} from "shared/search/containers/FilterGroup/GeographyFilterGroups"
import {
    GrassrootsActionCampaignFilterGroup,
    GrassrootsActionDateFilterGroup,
    GrassrootsActionInvolvingFilterGroup,
    GrassrootsActionPacFilterGroup,
    GrassrootsActionSocialMediaTypeFilterGroup,
    GrassrootsActionSourceFilterGroup,
    GrassrootsActionSubmittingOrganizationFilterGroup,
    GrassrootsActionTypeFilterGroup,
    GrassrootsCustomActionFieldsFilterGroup,
    GrassrootsListFilterGroup,
} from "shared/search/containers/FilterGroup/GrassrootsActionFilterGroups"
import { IssueIssuesFilterGroup } from "shared/search/containers/FilterGroup/IssueFilterGroups"
import {
    IssueManagementCustomFilterGroup,
    IssueManagementIssueTypeFilterGroup,
} from "shared/search/containers/FilterGroup/IssueManagementFilterGroups"
import {
    NoteCreatedDateFilterGroup,
    NoteCustomFilterGroup,
    NoteDonationFilterGroup,
    NoteDurationFilterGroup,
    NoteInteractionTypeFilterGroup,
    NoteInvisibleFilterGroup,
    NoteInvolvingFilterGroup,
    NoteListFilterGroup,
    NoteMentionFilterGroup,
    NoteOrderByFilterGroup,
    // for organization profile
    NoteOrganizationProfileFilterGroup,
    NoteProjectFilterGroup,
    NoteRegionFilterGroup,
    NoteSourceFilterGroup,
    NoteStartDateFilterGroup,
    NoteStartDateNoPastFilterGroup,
    NoteTypeFilterGroup,
} from "shared/search/containers/FilterGroup/NoteFilterGroups"
import {
    // for EU
    EULegislativeActionsFilterGroup,
    ExecutiveTypeFilterGroup,
    // for bill profile
    LegislatorBillSponsorGroup,
    LegislatorTypeFilterGroup,
    OfficialAssumedOfficeFilterGroup,
    OfficialBiographyFilterGroup,
    OfficialCampaignFilterGroup,
    OfficialCommitteeFilterGroup,
    OfficialCustomEventFilterGroup,
    OfficialCustomFilterGroup,
    OfficialDataMaintenanceFilterGroup,
    OfficialExecutiveRoleFilterGroup,
    OfficialLegislativeActionsFilterGroup,
    OfficialLegislativeRoleFilterGroup,
    OfficialPACTransactionsFilterGroup,
    OfficialPartyFilterGroup,
    OfficialsCampaignFinanceFilterGroup,
    OfficialTypeFilterGroup,
    OfficialWorksForFilterGroup,
    PersonDocumentFilterGroup,
    PersonInteractionFilterGroup,
    PersonListFilterGroup,
    // for organization profile
    PersonOrganizationProfileFilterGroup,
    PersonOutboxFilterGroup,
    PersonPriorityFilterGroup,
    PersonProjectFilterGroup,
    PersonRepresentingFilterGroup,
    PersonRepresentsInternationalRegionFilterGroup,
    PersonRepresentsRegionFilterGroup,
    PersonStakeholderFilterGroup,
    PressContactCustomEventFilterGroup,
    PressContactCustomFilterGroup,
    PressContactDataMaintenanceFilterGroup,
    PressContactInteractionFilterGroup,
    PressContactLanguageFilterGroup,
    PressContactListFilterGroup,
    PressContactNewsArticlesFilterGroup,
    PressContactOutletFilterGroup,
    PressContactRegionFilterGroup,
    PressContactSocialMediaFilterGroup,
    PressContactTypeFilterGroup,
} from "shared/search/containers/FilterGroup/OfficialFilterGroups"
import {
    OfficialInOutboxLegislativeRoleFilterGroup,
    OfficialInOutboxTypeFilterGroup,
} from "shared/search/containers/FilterGroup/OfficialInOutboxFilterGroups"
import { PacClassicPacOfficeFilterGroup } from "shared/search/containers/FilterGroup/PacClassicPacOfficeFilterGroups"
import {
    PacClassicPacOrganizationCandidateFilterGroup,
    PacClassicPacOrganizationPACActivityFilterGroup,
    PacClassicPacOrganizationOfficialsFilterGroup,
} from "shared/search/containers/FilterGroup/PacClassicPacOrganizationFilterGroups"
import { ProjectTypeFilterGroup } from "shared/search/containers/FilterGroup/ProjectFilterGroups"
import {
    PublicOrganizationCustomFilterGroup,
    PublicOrganizationDataMaintenanceFilterGroup,
    PublicOrganizationDocumentFilterGroup,
    PublicOrganizationListFilterGroup,
    PublicOrganizationOrderByFilterGroup,
    // for organization profile
    PublicOrganizationOrganizationProfileFilterGroup,
    PublicOrganizationOutletFilterGroup,
    PublicOrganizationPacFilterGroup,
    PublicOrganizationParentFilterGroup,
    PublicOrganizationProjectFilterGroup,
    PublicOrganizationRegionFilterGroup,
    PublicOrganizationSocialMediaFilterGroup,
    PublicOrganizationTypeFilterGroup,
} from "shared/search/containers/FilterGroup/PublicOrganizationFilterGroups"
import {
    RegulationCommentAssociatedFilterGroup,
    RegulationCommentDateFilterGroup,
    RegulationCommentSourceTypeFilterGroup,
} from "shared/search/containers/FilterGroup/RegulationCommentFilterGroups"
import {
    RegulationAgencyFilterGroup,
    RegulationAuthorityCitationSearchFilterGroup,
    RegulationCustomFilterGroup,
    RegulationDateFilterGroup,
    RegulationDocketFilterGroup,
    RegulationListFilterGroup,
    RegulationOrderByFilterGroup,
    RegulationPriorityFilterGroup,
    RegulationProjectFilterGroup,
    RegulationProposalYearFilterGroup,
    RegulationRegionFilterGroup,
    RegulationReviewFilterGroup,
    RegulationSearchFilterGroup,
    RegulationStanceFilterGroup,
    RegulationStatusFilterGroup,
    RegulationTrackingDashboardFilterGroup,
    RegulationTypeFilterGroup,
} from "shared/search/containers/FilterGroup/RegulationFilterGroups"
import {
    ReplyEmailDateFilterGroup,
    ReplyEmailSearchFilterGroup,
    ReplyEmailSendEmailFilterGroup,
    ReplyEmailSourceFilterGroup,
} from "shared/search/containers/FilterGroup/ReplyEmailFilterGroups"
import {
    ClickedLinkFilterFilterGroup,
    SendEmailBulkEmailFilterGroup,
    SendEmailCampaignFilterGroup,
    SendEmailDateFilterGroup,
    SendEmailOrderByFilterGroup,
    SendEmailRecipientFilterGroup,
    SendEmailStatusFilterGroup,
} from "shared/search/containers/FilterGroup/SendEmailFilterGroups"
import {
    // for committee profile
    StafferCommitteeProfileFilterGroup,
    StafferCustomEventFilterGroup,
    StafferCustomFilterGroup,
    StafferDataMaintenanceFilterGroup,
    StafferListFilterGroup,
    StafferProjectFilterGroup,
    StafferRepresentsRegionFilterGroup,
    StafferTypeFilterGroup,
} from "shared/search/containers/FilterGroup/StafferFilterGroups"
import { StatisticDemographicFilterGroup } from "shared/search/containers/FilterGroup/StatisticFilterGroups"
import {
    SupporterAssignmentFilterGroup,
    SupporterCampaignFilterGroup,
    SupporterCampaignFinanceFilterGroup,
    // for custom events
    SupporterCustomEventFilterGroup,
    SupporterCustomFilterGroup,
    SupporterDataMaintenanceFilterGroup,
    SupporterDateFilterGroup,
    SupporterGeographyFilterGroup,
    SupporterLegislatorsFilterGroup,
    SupporterListFilterGroup,
    SupporterOrderByFilterGroup,
    SupporterOrganizationFilterGroup,
    // for organization profile
    SupporterOrganizationProfileFilterGroup,
    SupporterOutboxFilterGroup,
    SupporterPACFilterGroup,
    SupporterProjectFilterGroup,
    SupporterSearchFilterGroup,
    SupporterStakeholderFilterGroup,
    SupporterTextFilterGroup,
} from "shared/search/containers/FilterGroup/SupporterFilterGroups"
import { TeamReferenceFilterGroup } from "shared/search/containers/FilterGroup/TeamFilterGroups"
import { UserOrganizationFilterGroup, UserTeamFilterGroup } from "shared/search/containers/FilterGroup/UserFilterGroups"
import {
    VoteCategoryFilterGroup,
    VoteCompareFilterGroup,
    VoteDateRangeFilterGroup,
    VoteIssueFilterGroup,
    VoteListFilterGroup,
    VoteMultiFilterGroup,
    VoteOrderByFilterGroup,
    VoteProjectFilterGroup,
    VoteReferenceFilterGroup,
    VoteReferenceInBillProfileFilterGroup,
    VoteResultFilterGroup,
    VoteSessionFilterGroup,
    VoteStanceFilterGroup,
} from "shared/search/containers/FilterGroup/VoteFilterGroups"
import {
    VoteResultDateFilterGroup,
    VoteResultPartyFilterGroup,
    VoteResultPartyStance,
    VoteResultReferenceFilterGroup,
    VoteResultSearchFilterGroup,
    VoteResultTypeFilterGroup,
} from "shared/search/containers/FilterGroup/VoteResultFilterGroups"
import FilterSet from "shared/search/containers/FilterSet/index"

import {
    TransactionAmountFilterGroup,
    TransactionContributionTypeFilterGroup,
    TransactionDetailsFilterGroup,
    TransactionElectionFilterGroup,
    TransactionOfficialFilterGroup,
    TransactionPoliticalCommitteeFilterGroup,
    TransactionPublicOrganizationFilterGroup,
    TransactionSupporterFilterGroup,
    TransactionTypeFilterGroup,
} from "shared/search/containers/FilterGroup/TransactionFilterGroups"

import {
    PacClassicPacTransactionAmountFilterGroup,
    PacClassicPacTransactionDetailsFilterGroup,
    PacClassicPacTransactionElectionFilterGroup,
    PacClassicPacTransactionOrganizationFilterGroup,
    // TODO: after adding PacClassicLegislator model
    // PacClassicPacTransactionOfficialFilterGroup,
    PacClassicPacTransactionPacOrganizationFilterGroup,
    PacClassicPacTransactionSupporterFilterGroup,
    PacClassicPacTransactionTypeFilterGroup,
} from "shared/search/containers/FilterGroup/PacClassicPacTransactionFilterGroups"

import {
    PoliticalCommitteeCampaignFinanceFilterGroup,
    PoliticalCommitteeCandidateFilterGroup,
    PoliticalCommitteeDetailsFilterGroup,
    PoliticalCommitteeFecPartyTypeFilterGroup,
    PoliticalCommitteeOfficialsFilterGroup,
    PoliticalCommitteeStateRegionFilterGroup,
    PoliticalCommitteeTransactionFilterGroup,
    PoliticalCommitteeTypeFilterGroup,
} from "shared/search/containers/FilterGroup/PoliticalCommitteeFilterGroups"

import {
    DisbursementsAmountMinFilterGroup,
    DisbursementsDateFilterGroup,
    DisbursementsRecipientTypeFilterGroup,
    DisbursementsTypeFilterGroup,
} from "shared/search/containers/FilterGroup/DisbursementsFilterGroups"

import { usRegions } from "shared/imports/regionConstants"
import * as constants from "shared/imports/sharedConstants"
import { SearchBarFilter } from "shared/search/containers/Filter/Filters"
import { bulkUploadIsAvailable } from "shared/search/helperFunctions"
import { getBillLanguageFilterOptions } from "shared/selects/helperFunctions"

import { isGrassrootsPersona } from "shared/grassroots/helperFunctions"
import {
    ReceiptsAmountMinFilterGroup,
    ReceiptsDateFilterGroup,
    ReceiptsElectionTypeFilterGroup,
    ReceiptsPartyFilterGroup,
    ReceiptsRecipientTypeFilterGroup,
    ReceiptsTypeFilterGroup,
} from "shared/search/containers/FilterGroup/ReceiptsFilterGroups"
import { hasAnyPermission } from "shared/imports/permissionFunctions"
import {
    SendSMSRecipientsFilterGroup,
    SendSMSTextFilterGroup,
    SendSMSStatusFilterGroup,
    SendSMSDateCreatedFilterGroup,
    SendSMSCampaignFilterGroup,
} from "shared/search/containers/FilterGroup/SendSMSFilterGroups"

// GenericFilterSet will provide a FilterSet equipped only with
// and SearchBarFilter and empty FilterGroups. Used for Searchify instances
// where we don't have filters.

export default function genericFilterSet(props) {
    return (
        <FilterSet
            filterGroups={props.filterGroups}
            searchBarComponent={props.searchBarComponent || SearchBarFilter}
            {...props}
        />
    )
}

genericFilterSet.propTypes = {
    filterGroups: PropTypes.array,
    searchBarComponent: PropTypes.func,
}

genericFilterSet.defaultProps = {
    filterGroups: [],
    searchBarComponent: SearchBarFilter,
}

export const OfficialFilterSet = (props) => genericFilterSet(props)
OfficialFilterSet.defaultProps = {
    filterGroups: [
        OfficialCustomFilterGroup,
        OfficialTypeFilterGroup,
        OfficialLegislativeRoleFilterGroup,
        OfficialExecutiveRoleFilterGroup,
        OfficialPartyFilterGroup,
        OfficialCommitteeFilterGroup,
        OfficialLegislativeActionsFilterGroup,
        OfficialAssumedOfficeFilterGroup,
        ...(Userdata.isOnlyEUMode() || Userdata.current_regions_values.every((r) => usRegions.includes(r))
            ? [PersonRepresentsRegionFilterGroup]
            : [PersonRepresentsInternationalRegionFilterGroup]),
        OfficialCampaignFilterGroup,
        OfficialsCampaignFinanceFilterGroup,
        ...(hasAnyPermission([DjangIO.app.models.PermissionType.qpac_v1]) ? [OfficialPACTransactionsFilterGroup] : []),
        PersonRepresentingFilterGroup,
        PersonStakeholderFilterGroup,
        PersonProjectFilterGroup,
        PersonListFilterGroup,
        AssignmentFilterGroup,
        PersonInteractionFilterGroup,
        PersonOutboxFilterGroup,
        OfficialCustomEventFilterGroup,
        OfficialBiographyFilterGroup,
        PersonDocumentFilterGroup,
        InvisibleDefaultFilterGroup,
        ...(bulkUploadIsAvailable(DjangIO.app.custom_data.types.BulkUploadType.official)
            ? [OfficialDataMaintenanceFilterGroup]
            : []),
    ],
    name: "OfficialFilterSet",
}

export const OfficialWitoutCampaignFinanceFilterSet = (props) => genericFilterSet(props)
OfficialWitoutCampaignFinanceFilterSet.defaultProps = {
    filterGroups: [
        OfficialCustomFilterGroup,
        OfficialTypeFilterGroup,
        OfficialLegislativeRoleFilterGroup,
        OfficialExecutiveRoleFilterGroup,
        OfficialPartyFilterGroup,
        OfficialCommitteeFilterGroup,
        OfficialLegislativeActionsFilterGroup,
        OfficialAssumedOfficeFilterGroup,
        ...(Userdata.isOnlyEUMode() || Userdata.current_regions_values.every((r) => usRegions.includes(r))
            ? [PersonRepresentsRegionFilterGroup]
            : [PersonRepresentsInternationalRegionFilterGroup]),
        OfficialCampaignFilterGroup,
        ...(hasAnyPermission([DjangIO.app.models.PermissionType.qpac_v1]) ? [OfficialPACTransactionsFilterGroup] : []),
        PersonRepresentingFilterGroup,
        PersonStakeholderFilterGroup,
        PersonProjectFilterGroup,
        PersonListFilterGroup,
        AssignmentFilterGroup,
        PersonInteractionFilterGroup,
        PersonOutboxFilterGroup,
        OfficialCustomEventFilterGroup,
        OfficialBiographyFilterGroup,
        PersonDocumentFilterGroup,
        InvisibleDefaultFilterGroup,
        ...(bulkUploadIsAvailable(DjangIO.app.custom_data.types.BulkUploadType.official)
            ? [OfficialDataMaintenanceFilterGroup]
            : []),
    ],
    name: "OfficialWitoutCampaignFinanceFilterSet",
}

export const OfficialInOrganizationProfileFilterSet = (props) => genericFilterSet(props)
OfficialInOrganizationProfileFilterSet.defaultProps = {
    filterGroups: [
        PersonOrganizationProfileFilterGroup,
        OfficialCustomFilterGroup,
        OfficialTypeFilterGroup,
        OfficialLegislativeRoleFilterGroup,
        OfficialExecutiveRoleFilterGroup,
        OfficialPartyFilterGroup,
        OfficialCommitteeFilterGroup,
        OfficialLegislativeActionsFilterGroup,
        OfficialAssumedOfficeFilterGroup,
        ...(Userdata.isOnlyEUMode() || Userdata.current_regions_values.every((r) => usRegions.includes(r))
            ? [PersonRepresentsRegionFilterGroup]
            : [PersonRepresentsInternationalRegionFilterGroup]),
        OfficialCampaignFilterGroup,
        ...(hasAnyPermission([DjangIO.app.models.PermissionType.qpac_v1]) ? [OfficialPACTransactionsFilterGroup] : []),
        PersonRepresentingFilterGroup,
        PersonStakeholderFilterGroup,
        PersonProjectFilterGroup,
        AssignmentFilterGroup,
        PersonListFilterGroup,
        PersonInteractionFilterGroup,
        PersonOutboxFilterGroup,
        OfficialCustomEventFilterGroup,
        OfficialBiographyFilterGroup,
        PersonDocumentFilterGroup,
        InvisibleDefaultFilterGroup,
        ...(bulkUploadIsAvailable(DjangIO.app.custom_data.types.BulkUploadType.official)
            ? [OfficialDataMaintenanceFilterGroup]
            : []),
    ],
}

export class OfficialInOutboxFilterSet extends Component {
    static defaultProps = {
        filterGroups: [
            OfficialCustomFilterGroup,
            OfficialInOutboxTypeFilterGroup,
            OfficialInOutboxLegislativeRoleFilterGroup,
            OfficialExecutiveRoleFilterGroup,
            OfficialPartyFilterGroup,
            OfficialCommitteeFilterGroup,
            OfficialLegislativeActionsFilterGroup,
            OfficialAssumedOfficeFilterGroup,
            ...(Userdata.isOnlyEUMode() || Userdata.current_regions_values.every((r) => usRegions.includes(r))
                ? [PersonRepresentsRegionFilterGroup]
                : [PersonRepresentsInternationalRegionFilterGroup]),
            OfficialCampaignFilterGroup,
            ...(hasAnyPermission([DjangIO.app.models.PermissionType.qpac_v1])
                ? [OfficialPACTransactionsFilterGroup]
                : []),
            PersonRepresentingFilterGroup,
            PersonStakeholderFilterGroup,
            PersonProjectFilterGroup,
            AssignmentFilterGroup,
            PersonListFilterGroup,
            PersonInteractionFilterGroup,
            PersonOutboxFilterGroup,
            OfficialCustomEventFilterGroup,
            OfficialBiographyFilterGroup,
            PersonDocumentFilterGroup,
            InvisibleDefaultFilterGroup,
            ...(bulkUploadIsAvailable(DjangIO.app.custom_data.types.BulkUploadType.official)
                ? [OfficialDataMaintenanceFilterGroup]
                : []),
        ],
    }

    render() {
        return genericFilterSet(this.props)
    }
}

export class StafferFilterSet extends Component {
    static defaultProps = {
        filterGroups: [
            StafferCustomFilterGroup,
            StafferTypeFilterGroup,
            StafferRepresentsRegionFilterGroup,
            PersonRepresentsInternationalRegionFilterGroup,
            PersonStakeholderFilterGroup,
            StafferProjectFilterGroup,
            StafferListFilterGroup,
            AssignmentFilterGroup,
            PersonInteractionFilterGroup,
            PersonOutboxFilterGroup,
            StafferCustomEventFilterGroup,
            InvisibleDefaultFilterGroup,
            ...(bulkUploadIsAvailable(DjangIO.app.custom_data.types.BulkUploadType.staffer)
                ? [StafferDataMaintenanceFilterGroup]
                : []),
        ],
        name: "StafferFilterSet",
    }

    render() {
        return genericFilterSet(this.props)
    }
}
export class StafferInCommitteeProfileFilterSet extends Component {
    static defaultProps = {
        filterGroups: [
            StafferCommitteeProfileFilterGroup,
            StafferCustomFilterGroup,
            StafferTypeFilterGroup,
            StafferRepresentsRegionFilterGroup,
            PersonRepresentsInternationalRegionFilterGroup,
            PersonStakeholderFilterGroup,
            StafferProjectFilterGroup,
            StafferListFilterGroup,
            AssignmentFilterGroup,
            PersonInteractionFilterGroup,
            PersonOutboxFilterGroup,
            StafferCustomEventFilterGroup,
            InvisibleDefaultFilterGroup,
            ...(bulkUploadIsAvailable(DjangIO.app.custom_data.types.BulkUploadType.staffer)
                ? [StafferDataMaintenanceFilterGroup]
                : []),
        ],
    }

    render() {
        return genericFilterSet(this.props)
    }
}

export class OfficialAndStaffEUFilterSet extends Component {
    static defaultProps = {
        filterGroups: [
            OfficialCustomFilterGroup,
            StafferCustomFilterGroup,
            OfficialTypeFilterGroup,
            OfficialPartyFilterGroup,
            OfficialCommitteeFilterGroup,
            OfficialWorksForFilterGroup,
            ...(Userdata.isOnlyEUMode() || Userdata.current_regions_values.every((r) => usRegions.includes(r))
                ? [PersonRepresentsRegionFilterGroup]
                : [PersonRepresentsInternationalRegionFilterGroup]),
            OfficialCampaignFilterGroup,
            PersonRepresentingFilterGroup,
            OfficialAssumedOfficeFilterGroup,
            PersonStakeholderFilterGroup,
            PersonProjectFilterGroup,
            PersonListFilterGroup,
            AssignmentFilterGroup,
            PersonInteractionFilterGroup,
            PersonOutboxFilterGroup,
            EULegislativeActionsFilterGroup,
            PersonDocumentFilterGroup,
            OfficialCustomEventFilterGroup,
            OfficialBiographyFilterGroup,
            ...(bulkUploadIsAvailable(DjangIO.app.custom_data.types.BulkUploadType.official)
                ? [OfficialDataMaintenanceFilterGroup]
                : []),
        ],
    }

    render() {
        return genericFilterSet(this.props)
    }
}

export const PressContactFilterSet = (props) => genericFilterSet(props)
PressContactFilterSet.defaultProps = {
    filterGroups: [
        PressContactCustomFilterGroup,
        PressContactTypeFilterGroup,
        PressContactOutletFilterGroup,
        PressContactNewsArticlesFilterGroup,
        ...(Userdata.Permissions.is_comms_only ? [PressContactSocialMediaFilterGroup] : []),
        PressContactRegionFilterGroup,
        PressContactListFilterGroup,
        PersonStakeholderFilterGroup,
        PersonPriorityFilterGroup,
        PersonProjectFilterGroup,
        AssignmentFilterGroup,
        PressContactInteractionFilterGroup,
        PersonOutboxFilterGroup,
        PressContactLanguageFilterGroup,
        // PressContactBiographyFilterGroup,
        PressContactCustomEventFilterGroup,
        PressContactDataMaintenanceFilterGroup,
        InvisibleDefaultFilterGroup,
    ],
}

export class BillFilterSet extends Component {
    static defaultProps = {
        filterGroups: [
            BillCustomFilterGroup,
            BillDateFilterGroup,
            ...(getBillLanguageFilterOptions().length > 1 ? [BillLanguageFilterGroup] : []),
            ...(Userdata.isGlobalMode() ? [] : [BillTypeFilterGroup]),
            BillStatusFilterGroup,
            BillSupportedRegionFilterGroup,
            ...(Userdata.isGlobalMode() ? [] : [BillSourceFilterGroup]),
            BillStanceFilterGroup,
            BillPriorityFilterGroup,
            BillProjectFilterGroup,
            BillListFilterGroup,
            AssignmentFilterGroup,
            BillTrackingDashboardFilterGroup,
            BillSponsorFilterGroup,
            ...(Userdata.isGlobalMode() ? [] : [BillCommitteeFilterGroup]),
            BillTitleFilterGroup,
            ...(Userdata.isGlobalMode() ? [] : [BillTermFilterGroup]),
            ...(Userdata.isGlobalMode() ? [] : [BillCompanionFilterGroup]),
            ...(Userdata.isGlobalMode() ? [] : [BillRelatedFilterGroup]),
            BillInvisibleFilterGroup,
            InvisibleDefaultFilterGroup,
            BillOrderByFilterGroup,
            ...(bulkUploadIsAvailable(DjangIO.app.custom_data.types.BulkUploadType.bill)
                ? [BillDataMaintenanceFilterGroup]
                : []),
            BillReviewFilterGroup,
            FromTrackingBoardInvisibleFilterGroup,
        ],
        name: "BillFilterSet",
    }

    render() {
        return genericFilterSet(this.props)
    }
}

export class BillInCommitteeProfileFilterSet extends Component {
    static defaultProps = {
        filterGroups: [
            BillCommitteeProfileFilterGroup,
            BillCustomFilterGroup,
            ...(Userdata.isOnlyEUMode()
                ? [BillTypeFilterGroup, BillDateFilterGroup]
                : [BillDateFilterGroup, BillTypeFilterGroup]),
            BillStatusFilterGroup,
            BillSupportedRegionFilterGroup,
            BillSourceFilterGroup,
            BillStanceFilterGroup,
            BillPriorityFilterGroup,
            BillProjectFilterGroup,
            BillListFilterGroup,
            AssignmentFilterGroup,
            BillTrackingDashboardFilterGroup,
            BillSponsorFilterGroup,
            BillCommitteeFilterGroup,
            BillTitleFilterGroup,
            BillTermFilterGroup,
            BillCompanionFilterGroup,
            BillRelatedFilterGroup,
            BillInvisibleFilterGroup,
            InvisibleDefaultFilterGroup,
            BillOrderByFilterGroup,
            ...(bulkUploadIsAvailable(DjangIO.app.custom_data.types.BulkUploadType.bill)
                ? [BillDataMaintenanceFilterGroup]
                : []),
            BillReviewFilterGroup,
        ],
    }

    render() {
        return genericFilterSet(this.props)
    }
}

export const BillInOrganizationProfileFilterSet = (props) => genericFilterSet(props)
BillInOrganizationProfileFilterSet.defaultProps = {
    filterGroups: [
        BillOrganizationProfileFilterGroup,
        BillCustomFilterGroup,
        ...(Userdata.isOnlyEUMode()
            ? [BillTypeFilterGroup, BillDateFilterGroup]
            : [BillDateFilterGroup, BillTypeFilterGroup]),
        BillStatusFilterGroup,
        BillSupportedRegionFilterGroup,
        BillSourceFilterGroup,
        BillStanceFilterGroup,
        BillPriorityFilterGroup,
        BillProjectFilterGroup,
        BillListFilterGroup,
        AssignmentFilterGroup,
        BillTrackingDashboardFilterGroup,
        BillSponsorFilterGroup,
        BillCommitteeFilterGroup,
        BillTitleFilterGroup,
        BillTermFilterGroup,
        BillCompanionFilterGroup,
        BillRelatedFilterGroup,
        BillInvisibleFilterGroup,
        InvisibleDefaultFilterGroup,
        BillOrderByFilterGroup,
        ...(bulkUploadIsAvailable(DjangIO.app.custom_data.types.BulkUploadType.bill)
            ? [BillDataMaintenanceFilterGroup]
            : []),
        BillReviewFilterGroup,
    ],
}

export class DocumentFilterSet extends Component {
    static defaultProps = {
        filterGroups: [
            Userdata.Permissions.is_comms_only ? DocumentTypeCommsOnlyFilterGroup : DocumentTypeFilterGroup,
            DocumentSourceFilterGroup,
            DocumentDateFilterGroup,
            Userdata.Permissions.is_comms_only ? DocumentMentionCommsOnlyFilterGroup : DocumentMentionFilterGroup,
            DocumentRegionFilterGroup,
            DocumentStanceFilterGroup,
            DocumentProjectFilterGroup,
            DocumentListFilterGroup,
            DocumentTrackingDashboardFilterGroup,
            DocumentInvisibleFilterGroup,
            InvisibleDefaultFilterGroup,
            DocumentOrderByFilterGroup,
            DocumentReviewFilterGroup,
            FromTrackingBoardInvisibleFilterGroup,
        ],
        name: "DocumentFilterSet",
    }

    render() {
        return genericFilterSet(this.props)
    }
}

export class DocumentInCommitteeProfileFilterSet extends Component {
    static defaultProps = {
        filterGroups: [
            DocumentCommitteeProfileFilterGroup,
            DocumentTypeFilterGroup,
            DocumentSourceFilterGroup,
            DocumentDateFilterGroup,
            DocumentMentionFilterGroup,
            DocumentRegionFilterGroup,
            DocumentStanceFilterGroup,
            DocumentProjectFilterGroup,
            DocumentListFilterGroup,
            DocumentTrackingDashboardFilterGroup,
            DocumentInvisibleFilterGroup,
            InvisibleDefaultFilterGroup,
            DocumentOrderByFilterGroup,
            DocumentReviewFilterGroup,
        ],
    }

    render() {
        return genericFilterSet(this.props)
    }
}

export class SupporterFilterSet extends Component {
    static defaultProps = {
        filterGroups: isGrassrootsPersona()
            ? [
                  SupporterCampaignFilterGroup,
                  SupporterOutboxFilterGroup,
                  SupporterTextFilterGroup,
                  SupporterCustomFilterGroup,
                  SupporterSearchFilterGroup,
                  SupporterGeographyFilterGroup,
                  SupporterLegislatorsFilterGroup,
                  SupporterOrderByFilterGroup,
                  SupporterCustomEventFilterGroup,
                  SupporterDateFilterGroup,
                  SupporterOrganizationFilterGroup,
                  SupporterListFilterGroup,
                  SupporterDataMaintenanceFilterGroup,
                  InvisibleDefaultFilterGroup,
                  SupporterStakeholderFilterGroup,
                  SupporterProjectFilterGroup,
                  PersonInteractionFilterGroup,
                  SupporterAssignmentFilterGroup,
                  SupporterCampaignFinanceFilterGroup,
                  ...(isAnyFeatureEnabled("ff_pac", "ff_restricted_gr_pages") ? [SupporterPACFilterGroup] : []),
              ]
            : [
                  SupporterCustomFilterGroup,
                  SupporterSearchFilterGroup,
                  SupporterOrganizationFilterGroup,
                  SupporterGeographyFilterGroup,
                  SupporterStakeholderFilterGroup,
                  SupporterProjectFilterGroup,
                  SupporterListFilterGroup,
                  SupporterAssignmentFilterGroup,
                  SupporterLegislatorsFilterGroup,
                  SupporterCampaignFilterGroup,
                  ...(isAnyFeatureEnabled("ff_pac", "ff_restricted_gr_pages") ? [SupporterPACFilterGroup] : []),
                  SupporterDateFilterGroup,
                  PersonInteractionFilterGroup,
                  SupporterOutboxFilterGroup,
                  SupporterTextFilterGroup,
                  SupporterCustomEventFilterGroup,
                  InvisibleDefaultFilterGroup,
                  SupporterOrderByFilterGroup,
                  SupporterDataMaintenanceFilterGroup,
                  SupporterCampaignFinanceFilterGroup,
              ],
        name: "SupporterFilterSet",
    }

    render() {
        return genericFilterSet(this.props)
    }
}

export const SupporterInOrganizationProfileFilterSet = (props) => genericFilterSet(props)
SupporterInOrganizationProfileFilterSet.defaultProps = {
    filterGroups: [
        SupporterOrganizationProfileFilterGroup,
        SupporterCustomFilterGroup,
        SupporterSearchFilterGroup,
        SupporterOrganizationFilterGroup,
        SupporterGeographyFilterGroup,
        SupporterStakeholderFilterGroup,
        SupporterProjectFilterGroup,
        SupporterListFilterGroup,
        SupporterAssignmentFilterGroup,
        SupporterLegislatorsFilterGroup,
        SupporterCampaignFilterGroup,
        ...(isFeatureEnabled("ff_pac") ? [SupporterPACFilterGroup] : []),
        SupporterDateFilterGroup,
        PersonInteractionFilterGroup,
        SupporterOutboxFilterGroup,
        SupporterTextFilterGroup,
        SupporterCustomEventFilterGroup,
        InvisibleDefaultFilterGroup,
        SupporterOrderByFilterGroup,
        SupporterDataMaintenanceFilterGroup,
    ],
}

export class PublicOrganizationFilterSet extends Component {
    static defaultProps = {
        filterGroups: [
            PublicOrganizationCustomFilterGroup,
            PublicOrganizationTypeFilterGroup,
            PublicOrganizationOutletFilterGroup,
            PublicOrganizationParentFilterGroup,
            ...(Userdata.Permissions.is_comms_only
                ? [PublicOrganizationSocialMediaFilterGroup]
                : [PublicOrganizationDocumentFilterGroup]),
            PublicOrganizationRegionFilterGroup,
            PublicOrganizationProjectFilterGroup,
            AssignmentFilterGroup,
            PublicOrganizationListFilterGroup,
            InvisibleDefaultFilterGroup,
            PublicOrganizationOrderByFilterGroup,
            ...(hasAnyPermission([DjangIO.app.models.PermissionType.qpac_v1])
                ? [PublicOrganizationPacFilterGroup]
                : []),
            ...(bulkUploadIsAvailable(DjangIO.app.custom_data.types.BulkUploadType.public_organization)
                ? [PublicOrganizationDataMaintenanceFilterGroup]
                : []),
        ],
        name: "PublicOrganizationFilterSet",
    }

    render() {
        return genericFilterSet(this.props)
    }
}

export const PublicOrganizationInOrganizationProfileFilterSet = (props) => genericFilterSet(props)
PublicOrganizationInOrganizationProfileFilterSet.defaultProps = {
    filterGroups: [
        PublicOrganizationOrganizationProfileFilterGroup,
        PublicOrganizationCustomFilterGroup,
        PublicOrganizationTypeFilterGroup,
        PublicOrganizationOutletFilterGroup,
        PublicOrganizationParentFilterGroup,
        PublicOrganizationSocialMediaFilterGroup,
        PublicOrganizationRegionFilterGroup,
        PublicOrganizationProjectFilterGroup,
        AssignmentFilterGroup,
        PublicOrganizationListFilterGroup,
        InvisibleDefaultFilterGroup,
        PublicOrganizationOrderByFilterGroup,
        ...(hasAnyPermission([DjangIO.app.models.PermissionType.qpac_v1]) ? [PublicOrganizationPacFilterGroup] : []),
        ...(bulkUploadIsAvailable(DjangIO.app.custom_data.types.BulkUploadType.public_organization)
            ? [PublicOrganizationDataMaintenanceFilterGroup]
            : []),
    ],
}

export class NoteFilterSet extends Component {
    static defaultProps = {
        filterGroups: [
            NoteCustomFilterGroup,
            NoteTypeFilterGroup,
            NoteSourceFilterGroup,
            NoteInvolvingFilterGroup,
            NoteStartDateFilterGroup,
            NoteCreatedDateFilterGroup,
            ...(constants.GOOGLE_ACCOUNT_IDS.includes(Userdata.organization_id) ? [] : [NoteRegionFilterGroup]),
            NoteMentionFilterGroup,
            NoteProjectFilterGroup,
            NoteListFilterGroup,
            NoteDurationFilterGroup,
            NoteDonationFilterGroup,
            NoteInvisibleFilterGroup,
            InvisibleDefaultFilterGroup,
            NoteOrderByFilterGroup,
        ],
        name: "NoteFilterSet",
    }

    render() {
        return genericFilterSet(this.props)
    }
}

export const NoteInOrganizationProfileFilterSet = (props) => genericFilterSet(props)
NoteInOrganizationProfileFilterSet.defaultProps = {
    filterGroups: [
        NoteOrganizationProfileFilterGroup,
        NoteCustomFilterGroup,
        NoteTypeFilterGroup,
        NoteSourceFilterGroup,
        NoteInvolvingFilterGroup,
        NoteStartDateFilterGroup,
        NoteCreatedDateFilterGroup,
        NoteRegionFilterGroup,
        NoteMentionFilterGroup,
        NoteProjectFilterGroup,
        NoteListFilterGroup,
        NoteDurationFilterGroup,
        NoteDonationFilterGroup,
        NoteInvisibleFilterGroup,
        InvisibleDefaultFilterGroup,
        NoteOrderByFilterGroup,
    ],
}

export const NoteInCalendarEventWidgetFilterSet = (props) => genericFilterSet(props)
NoteInCalendarEventWidgetFilterSet.defaultProps = {
    filterGroups: [
        NoteCustomFilterGroup,
        NoteInteractionTypeFilterGroup,
        NoteInvolvingFilterGroup,
        NoteStartDateNoPastFilterGroup,
        NoteRegionFilterGroup,
        NoteMentionFilterGroup,
        NoteProjectFilterGroup,
        NoteListFilterGroup,
        NoteDurationFilterGroup,
        NoteDonationFilterGroup,
        NoteInvisibleFilterGroup,
        InvisibleDefaultFilterGroup,
        NoteOrderByFilterGroup,
    ],
}

export class GrassrootsActionFilterSet extends Component {
    static defaultProps = {
        filterGroups: [
            ...(hasAnyPermission([DjangIO.app.models.PermissionType.action_center_campaigns])
                ? [GrassrootsActionCampaignFilterGroup]
                : []),
            ...(isFeatureEnabled("ff_ngg_interactive_campaign_profile")
                ? [GrassrootsCustomActionFieldsFilterGroup]
                : []),
            GrassrootsActionDateFilterGroup,
            GrassrootsActionTypeFilterGroup,
            GrassrootsActionSourceFilterGroup,
            GrassrootsActionSocialMediaTypeFilterGroup,
            GrassrootsActionInvolvingFilterGroup,
            GrassrootsActionSubmittingOrganizationFilterGroup,
            ...(isFeatureEnabled("ff_pac") ? [GrassrootsActionPacFilterGroup] : []),
            NoteRegionFilterGroup,
            BillProjectFilterGroup,
            GrassrootsListFilterGroup,
            InvisibleDefaultFilterGroup,
            NoteOrderByFilterGroup,
        ],
        name: "GrassrootsActionFilterSet",
    }

    render() {
        return genericFilterSet(this.props)
    }
}

export const GrassrootsActionInOrganizationProfileFilterSet = (props) => genericFilterSet(props)
GrassrootsActionInOrganizationProfileFilterSet.defaultProps = {
    filterGroups: [
        NoteOrganizationProfileFilterGroup,
        ...(hasAnyPermission([DjangIO.app.models.PermissionType.action_center_campaigns])
            ? [GrassrootsActionCampaignFilterGroup]
            : []),
        GrassrootsActionDateFilterGroup,
        GrassrootsActionTypeFilterGroup,
        GrassrootsActionSourceFilterGroup,
        GrassrootsActionSocialMediaTypeFilterGroup,
        GrassrootsActionInvolvingFilterGroup,
        GrassrootsActionSubmittingOrganizationFilterGroup,
        ...(isFeatureEnabled("ff_pac") ? [GrassrootsActionPacFilterGroup] : []),
        NoteRegionFilterGroup,
        BillProjectFilterGroup,
        GrassrootsListFilterGroup,
        InvisibleDefaultFilterGroup,
        NoteOrderByFilterGroup,
    ],
}

export class EventFilterSet extends Component {
    static defaultProps = {
        filterGroups: [
            EventDateFilterGroup,
            EventTypeFilterGroup,
            EventChamberFilterGroup,
            EventRegionFilterGroup,
            EventMentionFilterGroup,
            EventProjectFilterGroup,
            InvisibleDefaultFilterGroup,
            EventOrderByFilterGroup,
            // Not rendering this yet, because we need to think about the backwards compatibility of replacing the above FilterGroup
            // EventSupportedRegionFilterGroup,
        ],
        name: "EventFilterSet",
    }

    render() {
        return genericFilterSet(this.props)
    }
}

export const EventInCommitteeProfileFilterSet = (props) => genericFilterSet(props)
EventInCommitteeProfileFilterSet.defaultProps = {
    filterGroups: [
        EventCommitteeProfileFilterGroup,
        EventDateFilterGroup,
        EventTypeFilterGroup,
        EventChamberFilterGroup,
        EventRegionFilterGroup,
        EventMentionFilterGroup,
        EventProjectFilterGroup,
        InvisibleDefaultFilterGroup,
        EventOrderByFilterGroup,
    ],
}

export const EventInOrganizationProfileFilterSet = (props) => genericFilterSet(props)
EventInOrganizationProfileFilterSet.defaultProps = {
    filterGroups: [
        EventOrganizationProfileFilterGroup,
        EventDateFilterGroup,
        EventTypeFilterGroup,
        EventChamberFilterGroup,
        EventRegionFilterGroup,
        EventMentionFilterGroup,
        EventProjectFilterGroup,
        InvisibleDefaultFilterGroup,
        EventOrderByFilterGroup,
    ],
}

export class EventParticipantFilterSet extends Component {
    static defaultProps = {
        filterGroups: [EventParticipantTypeFilterGroup],
    }

    render() {
        return genericFilterSet(this.props)
    }
}

export class VoteFilterSet extends Component {
    static defaultProps = {
        filterGroups: [
            VoteCategoryFilterGroup,
            VoteReferenceFilterGroup,
            VoteSessionFilterGroup,
            VoteDateRangeFilterGroup,
            RegionNoFederalFilterGroup,
            VoteResultFilterGroup,
            VoteStanceFilterGroup,
            VoteProjectFilterGroup,
            VoteListFilterGroup,
            VoteMultiFilterGroup,
            VoteIssueFilterGroup,
            VoteCompareFilterGroup,
            InvisibleDefaultFilterGroup,
            VoteOrderByFilterGroup,
        ],
    }

    render() {
        return genericFilterSet(this.props)
    }
}

export class VoteInBillProfileFilterSet extends Component {
    static defaultProps = {
        filterGroups: [
            VoteCategoryFilterGroup,
            VoteReferenceInBillProfileFilterGroup,
            VoteReferenceFilterGroup,
            VoteSessionFilterGroup,
            VoteDateRangeFilterGroup,
            RegionNoFederalFilterGroup,
            VoteResultFilterGroup,
            VoteStanceFilterGroup,
            VoteProjectFilterGroup,
            VoteListFilterGroup,
            VoteMultiFilterGroup,
            VoteIssueFilterGroup,
            VoteCompareFilterGroup,
            InvisibleDefaultFilterGroup,
            VoteOrderByFilterGroup,
        ],
    }

    render() {
        return genericFilterSet(this.props)
    }
}

export class VoteResultFilterSet extends Component {
    static defaultProps = {
        filterGroups: [
            VoteResultSearchFilterGroup,
            VoteStanceFilterGroup,
            VoteProjectFilterGroup,
            VoteListFilterGroup,
            VoteIssueFilterGroup,
            VoteSessionFilterGroup,
            VoteCategoryFilterGroup,
            VoteResultFilterGroup,
            VoteResultPartyFilterGroup,
            VoteResultTypeFilterGroup,
            VoteResultReferenceFilterGroup,
            VoteResultDateFilterGroup,
            VoteResultPartyStance,
        ],
    }

    render() {
        return genericFilterSet(this.props)
    }
}

export class AmendmentFilterSet extends Component {
    static defaultProps = {
        filterGroups: [
            AmendmentBillFilterGroup,
            AmendmentSessionFilterGroup,
            AmendmentTypeFilterGroup,
            AmendmentSponsorFilterGroup,
            AmendmentStatusFilterGroup,
            AmendmentStanceFilterGroup,
            AmendmentPriorityFilterGroup,
            AmendmentProjectFilterGroup,
            AmendmentListFilterGroup,
            InvisibleDefaultFilterGroup,
            AmendmentOrderByFilterGroup,
            AmendmentReviewFilterGroup,
            FromTrackingBoardInvisibleFilterGroup,
        ],
    }

    render() {
        return genericFilterSet(this.props)
    }
}

export class AmendmentInCommitteeProfileFilterSet extends Component {
    static defaultProps = {
        filterGroups: [
            AmendmentCommitteeProfileFilterGroup,
            AmendmentBillFilterGroup,
            AmendmentSessionFilterGroup,
            AmendmentTypeFilterGroup,
            AmendmentSponsorFilterGroup,
            AmendmentStatusFilterGroup,
            AmendmentStanceFilterGroup,
            AmendmentPriorityFilterGroup,
            AmendmentProjectFilterGroup,
            AmendmentListFilterGroup,
            InvisibleDefaultFilterGroup,
            AmendmentOrderByFilterGroup,
            AmendmentReviewFilterGroup,
        ],
    }

    render() {
        return genericFilterSet(this.props)
    }
}

export class CommitteeFilterSet extends Component {
    static defaultProps = {
        filterGroups: [
            CommitteeCustomFilterGroup,
            CommitteeTypeFilterGroup,
            CommitteeMemberFilterGroup,
            CommitteeSubcommitteeFilterGroup,
            RegionNoFederalFilterGroup,
            // Not rendering this yet, because we need to think about the backwards compatibility of replacing the above FilterGroup
            // CommitteeRegionFilterGroup,
            CommitteeProjectFilterGroup,
            CommitteeListFilterGroup,
        ],
    }

    render() {
        return genericFilterSet(this.props)
    }
}

export class CaucusFilterSet extends Component {
    static defaultProps = {
        filterGroups: [
            CaucusTypeFilterGroup,
            CaucusMemberFilterGroup,
            CaucusProjectFilterGroup,
            CaucusListFilterGroup,
            InvisibleDefaultFilterGroup,
        ],
    }

    render() {
        return genericFilterSet(this.props)
    }
}

export class RegulationFilterSet extends Component {
    static defaultProps = {
        filterGroups: [
            RegulationCustomFilterGroup,
            ...(Userdata.isGlobalMode() ? [] : [RegulationTypeFilterGroup]),
            RegulationAgencyFilterGroup,
            ...(Userdata.isGlobalMode() ? [] : [RegulationDocketFilterGroup]),
            RegulationStatusFilterGroup,
            RegulationDateFilterGroup,
            RegulationSearchFilterGroup,
            ...(Userdata.has_international_region ? [] : [RegulationAuthorityCitationSearchFilterGroup]),
            RegulationRegionFilterGroup,
            RegulationStanceFilterGroup,
            RegulationPriorityFilterGroup,
            RegulationProjectFilterGroup,
            RegulationListFilterGroup,
            AssignmentFilterGroup,
            RegulationTrackingDashboardFilterGroup,
            InvisibleDefaultFilterGroup,
            RegulationOrderByFilterGroup,
            RegulationReviewFilterGroup,
            FromTrackingBoardInvisibleFilterGroup,
            RegulationProposalYearFilterGroup,
        ],
    }

    render() {
        return genericFilterSet(this.props)
    }
}

export class RegulationCommentFilterSet extends Component {
    static defaultProps = {
        filterGroups: [
            RegulationCommentAssociatedFilterGroup,
            RegulationCommentSourceTypeFilterGroup,
            RegulationCommentDateFilterGroup,
        ],
    }

    render() {
        return genericFilterSet(this.props)
    }
}

export class LiveTranscriptFilterSet extends Component {
    static defaultProps = {
        filterGroups: [EventDateFilterGroup, InvisibleDefaultFilterGroup],
    }

    render() {
        return genericFilterSet(this.props)
    }
}

export class FileFilterSet extends Component {
    static defaultProps = {
        filterGroups: [
            FileProjectFilterGroup,
            FileListFilterGroup,
            InvisibleDefaultFilterGroup,
            FileOrderByFilterGroup,
        ],
    }

    render() {
        return genericFilterSet(this.props)
    }
}

/* SEARCHIFY */

export class BulkEmailFilterSet extends Component {
    static defaultProps = {
        filterGroups: [
            BulkEmailStatisticsFilterGroup,
            BulkEmailParticipantsFilterGroup,
            BulkEmailDateFilterGroup,
            BulkEmailRecipientFilterGroup,
            BulkEmailProjectFilterGroup,
        ],
    }

    render() {
        return genericFilterSet(this.props)
    }
}

export class CampaignFilterSet extends Component {
    static defaultProps = {
        filterGroups: [
            CampaignTypeFilterGroup,
            CampaignStatusFilterGroup,
            CampaignDateFilterGroup,
            CampaignProjectFilterGroup,
            CampaignCreatorFilterGroup,
        ],
    }

    render() {
        return genericFilterSet(this.props)
    }
}

export class StatisticFilterSet extends Component {
    static defaultProps = {
        filterGroups: [StatisticDemographicFilterGroup],
    }

    render() {
        return genericFilterSet(this.props)
    }
}

export class UserFilterSet extends Component {
    static defaultProps = {
        filterGroups: [UserTeamFilterGroup, UserOrganizationFilterGroup],
    }
    render() {
        return genericFilterSet(this.props)
    }
}

export class ProjectFilterSet extends Component {
    static defaultProps = {
        filterGroups: [ProjectTypeFilterGroup, AssignmentFilterGroup],
    }

    render() {
        return genericFilterSet(this.props)
    }
}

export class IssueManagementFilterSet extends Component {
    static defaultProps = {
        filterGroups: [IssueManagementIssueTypeFilterGroup, IssueManagementCustomFilterGroup],
    }

    render() {
        return genericFilterSet(this.props)
    }
}

export const LegislatorFilterSet = (props) => genericFilterSet(props)
LegislatorFilterSet.defaultProps = {
    filterGroups: [
        PersonPriorityFilterGroup,
        OfficialCustomFilterGroup,
        LegislatorTypeFilterGroup,
        OfficialLegislativeRoleFilterGroup,
        OfficialPartyFilterGroup,
        OfficialCommitteeFilterGroup,
        OfficialLegislativeActionsFilterGroup,
        OfficialAssumedOfficeFilterGroup,
        PersonRepresentsRegionFilterGroup,
        OfficialCampaignFilterGroup,
        OfficialsCampaignFinanceFilterGroup,
        PersonRepresentsInternationalRegionFilterGroup,
        PersonRepresentingFilterGroup,
        PersonStakeholderFilterGroup,
        PersonProjectFilterGroup,
        PersonListFilterGroup,
        AssignmentFilterGroup,
        PersonInteractionFilterGroup,
        PersonOutboxFilterGroup,
        OfficialCustomEventFilterGroup,
        OfficialBiographyFilterGroup,
        PersonDocumentFilterGroup,
        InvisibleDefaultFilterGroup,
    ],
}

export const LegislatorFilterSetWithoutCampaignFinance = (props) => genericFilterSet(props)
LegislatorFilterSetWithoutCampaignFinance.defaultProps = {
    filterGroups: [
        PersonPriorityFilterGroup,
        OfficialCustomFilterGroup,
        LegislatorTypeFilterGroup,
        OfficialLegislativeRoleFilterGroup,
        OfficialPartyFilterGroup,
        OfficialCommitteeFilterGroup,
        OfficialLegislativeActionsFilterGroup,
        OfficialAssumedOfficeFilterGroup,
        PersonRepresentsRegionFilterGroup,
        OfficialCampaignFilterGroup,
        PersonRepresentsInternationalRegionFilterGroup,
        PersonRepresentingFilterGroup,
        PersonStakeholderFilterGroup,
        PersonProjectFilterGroup,
        PersonListFilterGroup,
        AssignmentFilterGroup,
        PersonInteractionFilterGroup,
        PersonOutboxFilterGroup,
        OfficialCustomEventFilterGroup,
        OfficialBiographyFilterGroup,
        PersonDocumentFilterGroup,
        InvisibleDefaultFilterGroup,
    ],
}

export const ExecutiveFilterSet = (props) => genericFilterSet(props)
ExecutiveFilterSet.defaultProps = {
    filterGroups: [
        ExecutiveTypeFilterGroup,
        OfficialExecutiveRoleFilterGroup,
        OfficialCustomFilterGroup,
        OfficialPartyFilterGroup,
        OfficialAssumedOfficeFilterGroup,
        PersonRepresentsRegionFilterGroup,
        PersonRepresentsInternationalRegionFilterGroup,
        PersonRepresentingFilterGroup,
        PersonListFilterGroup,
        AssignmentFilterGroup,
        PersonInteractionFilterGroup,
        PersonOutboxFilterGroup,
        OfficialBiographyFilterGroup,
        PersonDocumentFilterGroup,
        OfficialCustomEventFilterGroup,
        InvisibleDefaultFilterGroup,
    ],
}

/*
    PROFILE SPECIFIC FILTER SETS
    (To be moved to a separate file at a later date)
*/

export class DocumentExcludeSourceFilterSet extends Component {
    static defaultProps = {
        filterGroups: [
            DocumentTypeFilterGroup,
            DocumentDateFilterGroup,
            DocumentMentionFilterGroup,
            DocumentRegionFilterGroup,
            DocumentStanceFilterGroup,
            DocumentTrackingDashboardFilterGroup,
            DocumentListFilterGroup,
            DocumentInvisibleFilterGroup,
            DocumentOrderByFilterGroup,
            DocumentReviewFilterGroup,
        ],
    }

    render() {
        return genericFilterSet(this.props)
    }
}

export class SocialDocumentFilterSet extends Component {
    static defaultProps = {
        filterGroups: [
            DocumentTypeSocialOnlyFilterGroup,
            DocumentDateFilterGroup,
            DocumentMentionFilterGroup,
            DocumentRegionFilterGroup,
            DocumentStanceFilterGroup,
            DocumentTrackingDashboardFilterGroup,
            DocumentListFilterGroup,
            DocumentInvisibleFilterGroup,
            DocumentReviewFilterGroup,
        ],
    }

    render() {
        return genericFilterSet(this.props)
    }
}

export const DocumentInOrganizationProfileFilterSet = (props) => genericFilterSet(props)
DocumentInOrganizationProfileFilterSet.defaultProps = {
    filterGroups: [
        DocumentOrganizationProfileFilterGroup,
        DocumentTypeFilterGroup,
        DocumentSourceFilterGroup,
        DocumentDateFilterGroup,
        DocumentMentionFilterGroup,
        DocumentRegionFilterGroup,
        DocumentStanceFilterGroup,
        DocumentProjectFilterGroup,
        DocumentListFilterGroup,
        DocumentTrackingDashboardFilterGroup,
        DocumentInvisibleFilterGroup,
        InvisibleDefaultFilterGroup,
        DocumentOrderByFilterGroup,
        DocumentReviewFilterGroup,
    ],
}

export const DocumentMembersInOrganizationProfileFilterSet = (props) => genericFilterSet(props)
DocumentMembersInOrganizationProfileFilterSet.defaultProps = {
    filterGroups: [
        DocumentMembersOrganizationProfileFilterGroup,
        DocumentTypeFilterGroup,
        DocumentSourceFilterGroup,
        DocumentDateFilterGroup,
        DocumentMentionFilterGroup,
        DocumentRegionFilterGroup,
        DocumentStanceFilterGroup,
        DocumentTrackingDashboardFilterGroup,
        DocumentListFilterGroup,
        DocumentInvisibleFilterGroup,
        InvisibleDefaultFilterGroup,
        DocumentOrderByFilterGroup,
        DocumentReviewFilterGroup,
    ],
}

export class StafferInOfficialProfileFilterSet extends Component {
    static defaultProps = {
        filterGroups: [
            StafferCustomFilterGroup,
            StafferTypeFilterGroup,
            StafferRepresentsRegionFilterGroup,
            PersonRepresentsInternationalRegionFilterGroup,
            PersonStakeholderFilterGroup,
            StafferProjectFilterGroup,
            StafferListFilterGroup,
            AssignmentFilterGroup,
            PersonInteractionFilterGroup,
            PersonOutboxFilterGroup,
            StafferCustomEventFilterGroup,
            InvisibleDefaultFilterGroup,
            ...(bulkUploadIsAvailable(DjangIO.app.custom_data.types.BulkUploadType.staffer)
                ? [StafferDataMaintenanceFilterGroup]
                : []),
        ],
    }

    render() {
        return genericFilterSet(this.props)
    }
}

export class OfficialInBillProfileFilterSet extends Component {
    static defaultProps = {
        filterGroups: [
            LegislatorBillSponsorGroup,
            OfficialCustomFilterGroup,
            OfficialTypeFilterGroup,
            OfficialLegislativeRoleFilterGroup,
            OfficialExecutiveRoleFilterGroup,
            OfficialPartyFilterGroup,
            OfficialCommitteeFilterGroup,
            OfficialLegislativeActionsFilterGroup,
            OfficialAssumedOfficeFilterGroup,
            PersonRepresentsRegionFilterGroup,
            PersonRepresentsInternationalRegionFilterGroup,
            OfficialCampaignFilterGroup,
            ...(hasAnyPermission([DjangIO.app.models.PermissionType.qpac_v1])
                ? [OfficialPACTransactionsFilterGroup]
                : []),
            PersonRepresentingFilterGroup,
            PersonStakeholderFilterGroup,
            PersonProjectFilterGroup,
            AssignmentFilterGroup,
            PersonListFilterGroup,
            PersonInteractionFilterGroup,
            PersonOutboxFilterGroup,
            OfficialCustomEventFilterGroup,
            OfficialBiographyFilterGroup,
            PersonDocumentFilterGroup,
            InvisibleDefaultFilterGroup,
            ...(bulkUploadIsAvailable(DjangIO.app.custom_data.types.BulkUploadType.official)
                ? [OfficialDataMaintenanceFilterGroup]
                : []),
        ],
    }

    render() {
        return genericFilterSet(this.props)
    }
}

export const BillInOfficialProfileFilterSet = (props) => genericFilterSet(props)

BillInOfficialProfileFilterSet.defaultProps = {
    filterGroups: [
        BillSponsorOfficialProfileFilterGroup,
        BillCustomFilterGroup,
        ...(Userdata.isOnlyEUMode()
            ? [BillTypeFilterGroup, BillDateFilterGroup]
            : [BillDateFilterGroup, BillTypeFilterGroup]),
        BillStatusFilterGroup,
        BillSupportedRegionFilterGroup,
        BillSourceFilterGroup,
        BillStanceFilterGroup,
        BillPriorityFilterGroup,
        BillProjectFilterGroup,
        BillListFilterGroup,
        AssignmentFilterGroup,
        BillTrackingDashboardFilterGroup,
        BillSponsorFilterGroup,
        BillCommitteeFilterGroup,
        BillTitleFilterGroup,
        BillTermFilterGroup,
        BillCompanionFilterGroup,
        BillRelatedFilterGroup,
        BillInvisibleFilterGroup,
        InvisibleDefaultFilterGroup,
        BillOrderByFilterGroup,
        ...(bulkUploadIsAvailable(DjangIO.app.custom_data.types.BulkUploadType.bill)
            ? [BillDataMaintenanceFilterGroup]
            : []),
        BillReviewFilterGroup,
    ],
}

export const GeographyFilterSet = (props) => genericFilterSet(props)
GeographyFilterSet.defaultProps = {
    filterGroups: [GeographyStateFilterGroup],
}

export const GeographyStateFilterSet = (props) => genericFilterSet(props)
GeographyStateFilterSet.defaultProps = {
    filterGroups: [GeographyPartyFilterGroup],
}

export const GeographyMunicipalityFilterSet = (props) => genericFilterSet(props)
GeographyMunicipalityFilterSet.defaultProps = {
    filterGroups: [GeographyStateAndCountyFilterGroup],
}

export const CustomDataGeographicFilterSet = (props) => genericFilterSet(props)
CustomDataGeographicFilterSet.defaultProps = {
    filterGroups: [CustomDataGeographicFilterGroup],
}

export const GeoShapeFilterSet = (props) => genericFilterSet(props)
GeoShapeFilterSet.defaultProps = {
    filterGroups: [GeoShapeTypeFilterGroup, GeographyStateFilterGroup],
}

export const GeoShapeForBriefBuilderFilterSet = (props) => genericFilterSet(props)
GeoShapeForBriefBuilderFilterSet.defaultProps = {
    filterGroups: [GeoShapeTypeForBriefBuilderFilterGroup, GeographyStateFilterGroup],
}

export const IssuesFilterSet = (props) => genericFilterSet(props)
IssuesFilterSet.defaultProps = {
    filterGroups: [IssueIssuesFilterGroup],
}

// Outbox (Receipients) dataset
export const SendEmailFilterSet = (props) => genericFilterSet(props)
SendEmailFilterSet.defaultProps = {
    filterGroups: [
        SendEmailBulkEmailFilterGroup,
        SendEmailRecipientFilterGroup,
        SendEmailDateFilterGroup,
        SendEmailStatusFilterGroup,
        SendEmailCampaignFilterGroup,
        BillProjectFilterGroup,
        ClickedLinkFilterFilterGroup,
        InvisibleDefaultFilterGroup,
        SendEmailOrderByFilterGroup,
    ],
}

export const SendSMSFilterSet = (props) => genericFilterSet(props)
SendSMSFilterSet.defaultProps = {
    filterGroups: [
        SendSMSTextFilterGroup,
        SendSMSRecipientsFilterGroup,
        SendSMSStatusFilterGroup,
        SendSMSDateCreatedFilterGroup,
        SendSMSCampaignFilterGroup,
    ],
}

export const ReplyEmailFilterSet = (props) => genericFilterSet(props)
ReplyEmailFilterSet.defaultProps = {
    filterGroups: [
        ReplyEmailSourceFilterGroup,
        ReplyEmailSendEmailFilterGroup,
        ReplyEmailSearchFilterGroup,
        ReplyEmailDateFilterGroup,
    ],
}

export const ReplyEmailTruncatedFilterSet = (props) => genericFilterSet(props)
ReplyEmailTruncatedFilterSet.defaultProps = {
    filterGroups: [ReplyEmailSearchFilterGroup, ReplyEmailDateFilterGroup],
}

export const AssignmentFilterSet = (props) => genericFilterSet(props)
AssignmentFilterSet.defaultProps = {
    filterGroups: [
        AssignmentTypeFilterGroup,
        AssignmentCreatorFilterGroup,
        AssignmentFilterGroup,
        AssignmentOrderingFilterGroup,
    ],
}

export const TeamFilterSet = (props) => genericFilterSet(props)
TeamFilterSet.defaultProps = {
    filterGroups: [TeamReferenceFilterGroup],
}

export const FeedItemFilterSet = (props) => genericFilterSet(props)
FeedItemFilterSet.defaultProps = {
    filterGroups: [
        ...(Userdata.is_admin ? [FeedItemAdminFilterGroup] : []),
        FeedItemAlertFilterGroup,
        FeedItemDataTypeFilterGroup,
        FeedItemUpdateTypeFilterGroup,
        FeedItemDatasetFilterGroup,
        FeedItemDateFilterGroup,
        FeedItemCreatorFilterGroup,
        FeedItemFrequencyFilterGroup,
        FeedItemDeliveryMediumFilterGroup,
        FeedItemStanceFilterGroup,
        FeedItemPriorityFilterGroup,
        FeedItemIssueFilterGroup,
        FeedItemInvisibleFilterGroup,
    ],
}

export const AlertFilterSet = (props) => genericFilterSet(props)
AlertFilterSet.defaultProps = {
    filterGroups: [
        ...(Userdata.is_admin ? [FeedItemAdminFilterGroup] : []),
        AlertAlertGroupFilterGroup,
        FeedItemDateFilterGroup,
        AlertCreatorFilterGroup,
        AlertDataTypeFilterGroup,
        AlertFrequencyFilterGroup,
        AlertUpdateTypeFilterGroup,
    ],
}

export const AlertGroupFilterSet = (props) => genericFilterSet(props)
AlertGroupFilterSet.defaultProps = {
    filterGroups: [FeedItemAdminFilterGroup],
}

export const ArticleFilterSet = (props) => genericFilterSet(props)
ArticleFilterSet.defaultProps = {
    filterGroups: ArticleFilterGroups,
}

export const ArticleTopicFilterSet = (props) => genericFilterSet(props)
ArticleTopicFilterSet.defaultProps = {
    filterGroups: [ArticleTopicLevelFilterGroup],
}

export const BulkSMSFilterSet = (props) => genericFilterSet(props)
BulkSMSFilterSet.defaultProps = {
    filterGroups: [
        BulkSMSDetailsFilterGroup,
        BulkSMSStatisticsFilterGroup,
        BulkSMSRecipientsFilterGroup,
        BulkSMSCreatedDateFilterGroup,
    ],
}

export const BulkUploadFilterSet = (props) => genericFilterSet(props)
BulkUploadFilterSet.defaultProps = {
    filterGroups: [],
}

export const CustomEventParticipantFilterSet = (props) => genericFilterSet(props)
CustomEventParticipantFilterSet.defaultProps = {
    filterGroups: [
        CustomEventParticipantEventFilterGroup,
        CustomEventParticipantStatusFilterGroup,
        CustomEventParticipantRecipientsFilterGroup,
        CustomEventParticipantDateFilterGroup,
    ],
}

export const AgencyFilterSet = (props) => genericFilterSet(props)
AgencyFilterSet.defaultProps = {
    filterGroups: [AgencyRegionFilterGroup],
}

export const DocketFilterSet = (props) => genericFilterSet(props)
DocketFilterSet.defaultProps = {
    filterGroups: [
        DocketTypeFilterGroup,
        DocketDateFilterGroup,
        DocketAssociatedObjectsFilterGroups,
        DocketSearchFilterGroup,
        DocketStanceFilterGroup,
        DocketPriorityFilterGroup,
        AssignmentFilterGroup,
        DocketOrderByFilterGroup,
    ],
}

export const PoliticalCommitteeFilterSet = (props) => genericFilterSet(props)
PoliticalCommitteeFilterSet.defaultProps = {
    filterGroups: [
        PoliticalCommitteeTypeFilterGroup,
        PoliticalCommitteeCandidateFilterGroup,
        PoliticalCommitteeTransactionFilterGroup,
        PoliticalCommitteeOfficialsFilterGroup,
        PoliticalCommitteeStateRegionFilterGroup,
        PoliticalCommitteeFecPartyTypeFilterGroup,
        PoliticalCommitteeCampaignFinanceFilterGroup,
        PoliticalCommitteeDetailsFilterGroup,
    ],
    name: "PoliticalCommitteeFilterSet",
}

export const PoliticalCommitteeCampaignFinanceFilterSet = (props) => genericFilterSet(props)
PoliticalCommitteeCampaignFinanceFilterSet.defaultProps = {
    filterGroups: [
        PoliticalCommitteeTypeFilterGroup,
        PoliticalCommitteeCandidateFilterGroup,
        PoliticalCommitteeTransactionFilterGroup,
        PoliticalCommitteeOfficialsFilterGroup,
        PoliticalCommitteeStateRegionFilterGroup,
        PoliticalCommitteeFecPartyTypeFilterGroup,
    ],
    name: "PoliticalCommitteeFilterSet",
}

export const TransactionFilterSet = (props) => genericFilterSet(props)
TransactionFilterSet.defaultProps = {
    filterGroups: [
        TransactionTypeFilterGroup,
        TransactionContributionTypeFilterGroup,
        TransactionAmountFilterGroup,
        TransactionElectionFilterGroup,
        TransactionSupporterFilterGroup,
        TransactionPoliticalCommitteeFilterGroup,
        TransactionOfficialFilterGroup,
        TransactionPublicOrganizationFilterGroup,
        TransactionDetailsFilterGroup,
        // TransactionLedgerSettingsFilterGroup, // TODO: show only when client has multiple pacs
    ],
    name: "TransactionFilterSet",
}

export const PacClassicPacTransactionFilterSet = (props) => genericFilterSet(props)
PacClassicPacTransactionFilterSet.defaultProps = {
    filterGroups: [
        PacClassicPacTransactionTypeFilterGroup,
        PacClassicPacTransactionAmountFilterGroup,
        PacClassicPacTransactionDetailsFilterGroup,
        PacClassicPacTransactionSupporterFilterGroup,
        // TODO: after adding PacClassicLegislator model
        // PacClassicPacTransactionOfficialFilterGroup,
        PacClassicPacTransactionPacOrganizationFilterGroup,
        PacClassicPacTransactionElectionFilterGroup,
        PacClassicPacTransactionOrganizationFilterGroup,
    ],
    name: "PacClassicPacTransactionFilterSet",
}

export const PacClassicPacTransactionInPacOrgFilterSet = (props) => genericFilterSet(props)
PacClassicPacTransactionInPacOrgFilterSet.defaultProps = {
    filterGroups: [
        PacClassicPacTransactionTypeFilterGroup,
        PacClassicPacTransactionAmountFilterGroup,
        PacClassicPacTransactionDetailsFilterGroup,
        PacClassicPacTransactionSupporterFilterGroup,
        PacClassicPacTransactionElectionFilterGroup,
    ],
    name: "PacClassicPacTransactionInPacOrgFilterSet",
}

export const PacClassicPacTransactionInOfficialFilterSet = (props) => genericFilterSet(props)
PacClassicPacTransactionInOfficialFilterSet.defaultProps = {
    filterGroups: [
        PacClassicPacTransactionTypeFilterGroup,
        PacClassicPacTransactionAmountFilterGroup,
        PacClassicPacTransactionDetailsFilterGroup,
        PacClassicPacTransactionSupporterFilterGroup,
        PacClassicPacTransactionElectionFilterGroup,
    ],
    name: "PacClassicPacTransactionInOfficialFilterSet",
}

export const PacClassicPacTransactionInSupporterFilterSet = (props) => genericFilterSet(props)
PacClassicPacTransactionInSupporterFilterSet.defaultProps = {
    filterGroups: [
        PacClassicPacTransactionTypeFilterGroup,
        PacClassicPacTransactionAmountFilterGroup,
        PacClassicPacTransactionDetailsFilterGroup,
        PacClassicPacTransactionSupporterFilterGroup,
        PacClassicPacTransactionElectionFilterGroup,
    ],
    name: "PacClassicPacTransactionInSupporterFilterSet",
}

export const PacClassicPacOfficeFilterSet = (props) => genericFilterSet(props)
PacClassicPacOfficeFilterSet.defaultProps = {
    filterGroups: [PacClassicPacOfficeFilterGroup],
    name: "PacClassicPacOfficeFilterSet",
}

export const PacClassicPacOrganizationFilterSet = (props) => genericFilterSet(props)
PacClassicPacOrganizationFilterSet.defaultProps = {
    filterGroups: [
        PacClassicPacOrganizationPACActivityFilterGroup,
        PacClassicPacOrganizationCandidateFilterGroup,
        PacClassicPacOrganizationOfficialsFilterGroup,
    ],
}

export const CampaignFinanceReceiptFilterSet = (props) => genericFilterSet(props)
CampaignFinanceReceiptFilterSet.defaultProps = {
    filterGroups: [
        ReceiptsTypeFilterGroup,
        ReceiptsRecipientTypeFilterGroup,
        ReceiptsElectionTypeFilterGroup,
        ReceiptsPartyFilterGroup,
        ReceiptsDateFilterGroup,
        ReceiptsAmountMinFilterGroup,
    ],
}

export const CampaignFinanceStakeholderReceiptFilterSet = (props) => genericFilterSet(props)
CampaignFinanceStakeholderReceiptFilterSet.defaultProps = {
    filterGroups: [],
}

export const CampaignFinanceDisbursementsFilterSet = (props) => genericFilterSet(props)
CampaignFinanceDisbursementsFilterSet.defaultProps = {
    filterGroups: [
        DisbursementsTypeFilterGroup,
        DisbursementsRecipientTypeFilterGroup,
        DisbursementsDateFilterGroup,
        DisbursementsAmountMinFilterGroup,
    ],
}

export const ElectionFilterSet = (props) => genericFilterSet(props)
ElectionFilterSet.defaultProps = {
    filterGroups: [ElectionTypeFilterGroup, ElectionCycleFilterGroup, ElectionAmountFilterGroup],
    name: "ElectionFilterSet",
}
